import Profile from '@/modules/profile/containers/Profile.vue';
import EditProfile from '@/modules/profile/containers/EditProfile.vue';
import Refer from '@/modules/profile/components/refer/Refer.vue';
import Notifications from '@/modules/profile/containers/Notifications.vue';

export default [
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { requiresNavbar: true },
    },
    {
        path: '/profile/edit',
        name: 'Edit profile',
        component: EditProfile,
        meta: { requiresNavbar: true },
    }, {
        path: '/profile/refer',
        name: 'Refer',
        component: Refer,
        meta: { requiresNavbar: true },
    }, {
        path: '/profile/notifications',
        name: 'Notifications',
        component: Notifications,
        meta: { requiresNavbar: true },
    },
]
